import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-packinglist',
  templateUrl: './packinglist.component.html',
  styleUrls: ['./packinglist.component.css']
})
export class PackinglistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/packinglist/packinglist.component.ts